import ParameterErrors from '../errors/ParameterErrors';
import PlotDetailedInformation from './PlotDetailedInformation';
const {throwNotProvided}=ParameterErrors;
export default class PlotDetailedInformationsManager {
	static get instance(){
		if(!PlotDetailedInformationsManager._instance)
			throw new Error('Not initialized');
		return PlotDetailedInformationsManager._instance;
	}/*
	static initialize({parentElement, addFavourite, removeFavourite}){
		if(PlotDetailedInformationsManager._instance)
			throw new Error('Already initialized');
		PlotDetailedInformationsManager._instance = new PlotDetailedInformationsManager({
			parentElement:parentElement, addFavourite:addFavourite, removeFavourite:removeFavourite
		});
	}*/
	constructor({parentElement, addFavourite, removeFavourite, showStreetView, showImagesFullScreen, configuration, showBrochureGenerationDialog, enterHouse}){
		this._parentElement = parentElement;
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackShowStreetView = showStreetView;
		this._callbackShowImagesFullScreen = showImagesFullScreen;
		this._callbackShowBrochureGenerationDialog = showBrochureGenerationDialog;
		this._callbackEnterHouse = enterHouse;
		this._callbackDisposePlotDetailedInformation = this._callbackDisposePlotDetailedInformation.bind(this);
		this._plotNumberChanged = this._plotNumberChanged.bind(this);
		this.show = this.show.bind(this);
		this._plotDetailedInformations = [];
		this._configuration = configuration;
	}
	show(siteJsonUnitPlot){
		let plotDetailedInformation = this._plotDetailedInformations.filter(plotDetailedInformation=>plotDetailedInformation.number===siteJsonUnitPlot.number)[0];
		if(plotDetailedInformation){
			plotDetailedInformation.bringIntoFocus();
			return plotDetailedInformation;
		}
		plotDetailedInformation = new PlotDetailedInformation({
			siteJsonUnitPlot:siteJsonUnitPlot, 
			parentElement:this._parentElement,
			callbackDispose:this._callbackDisposePlotDetailedInformation,
			addFavourite:this._callbackAddFavourite,
			removeFavourite:this._callbackRemoveFavourite,
			showStreetView:this._callbackShowStreetView,
			showImagesFullScreen:this._callbackShowImagesFullScreen,
			configuration:this._configuration,
			showPlot:this.show,
			showBrochureGenerationDialog:this._callbackShowBrochureGenerationDialog,
			callbackPlotNumberChanged:this._plotNumberChanged,
			enterHouse:this._callbackEnterHouse
		});
		this._plotDetailedInformations.push(plotDetailedInformation);
		return plotDetailedInformation;
	}
	_plotNumberChanged(plotDetailedInformation, siteJsonUnitPlot){
		
	}
	_callbackDisposePlotDetailedInformation(plotDetailedInformation){
		const index = this._plotDetailedInformations.indexOf(plotDetailedInformation);
		if(index<0)return;
		this._plotDetailedInformations.splice(index, 1);
	}
}